import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSidebar } from "../../App";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpAccordion.css";

export default function Helprtoinput() {
  const { sidebarCollapsed } = useSidebar();
  const { t } = useTranslation("help");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  const defaultType = t("helprtoinput.table.defaultType", "reg_size_prompts");
  const promptsData = t("helprtoinput.table.prompts", {
    returnObjects: true,
    defaultValue: [
      "Explain what artificial intelligence is.",
      "Write a short paragraph about friendship.",
      "Summarize the history of the internet.",
      "Explain machine learning in simple terms.",
      "Why is cybersecurity important?",
      "Describe the software development lifecycle.",
      "What is cloud computing?",
      "Explain what an API is.",
      "What does an operating system do?",
      "Describe a fictional town.",
      "Explain how digestion works.",
      "What is climate change?",
      "Explain the basics of quantum physics.",
      "How does a website work?",
      "Write a short character description.",
      "What is a compiler?",
      "Explain microeconomics.",
      "What is a business plan?",
      "What is data science?",
      "How has warfare changed over time?",
      "What is space exploration?",
      "Explain how courts work.",
      "What is cloud security?",
      "What is philosophy?"
    ]
  });

  const promptList = Array.isArray(promptsData)
    ? promptsData
    : Object.values(promptsData || {});

  return (
    <div className="theme-whbl">
      <div className="container-fluid">
        <div className="main-container">
          {/* Main Content */}
          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{ width: "100%", overflowX: "auto", color: "#fff" }}
          >
            <div className="dashboard">
              {/* Page Title */}
              <div className="pm-header" style={{ marginBottom: "25px" }}>
                <h1
                  className="pm-title"
                  style={{ display: "block", width: "100%" }}
                >
                  {t(
                    "helprtoinput.title",
                    "Response Time Optimization Profile"
                  )}
                </h1>
              </div>

              {t(
                "helprtoinput.description",
                "Use this profile type to measure response latency and identify prompts, payloads, or model behaviors that degrade responsiveness. It is useful for performance baselining, regression testing, and validating response-time guardrails."
              )}

              <div>
                <br />
                <br />
                <img
                  className="help-img"
                  src="/images/rtoff.jpg"
                  alt="Attack Surface Tests Status"
                />
                <br />
                <br />

                <style>{`
                  .dark-guide-table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    font-family: Arial, sans-serif;
                    font-size: 14px;
                    color: #e5e7eb;
                    background: #111827;
                  }

                  .dark-guide-table th {
                    background: #1f2937;
                    color: #93c5fd;
                    font-weight: 600;
                    text-align: left;
                    padding: 12px 10px;
                    border: 1px solid #374151;
                    vertical-align: top;
                  }

                  .dark-guide-table td {
                    background: #111827;
                    color: #e5e7eb;
                    padding: 12px 10px;
                    border: 1px solid #374151;
                    vertical-align: top;
                    line-height: 1.5;
                    word-wrap: break-word;
                    overflow-wrap: anywhere;
                  }

                  .dark-guide-table tbody tr:hover td {
                    background: #1f2937;
                  }

                  .dark-guide-table th:nth-child(1),
                  .dark-guide-table td:nth-child(1) {
                    width: 30%;
                  }

                  .dark-guide-table th:nth-child(2),
                  .dark-guide-table td:nth-child(2) {
                    width: 70%;
                  }
                `}</style>

                <table className="dark-guide-table">
                  <thead>
                    <tr>
                      <th>{t("helprtoinput.table.headers.type", "type")}</th>
                      <th>{t("helprtoinput.table.headers.data", "data")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {promptList.map((prompt, index) => (
                      <tr key={index}>
                        <td>{defaultType}</td>
                        <td>{prompt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}